import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import { connect } from "react-redux";
import Spinner from "../../../common/Spinner";
import filterCaseInsensitive from "../../../custom/forms/react-table-case-insensitive";
import CustomCheckbox from "../../../custom/forms/custom-checkbox";

class NotExportedOrdersList extends Component {
    getUniqueOrderIds = () => {
        const uniqueIds = [];
        const { notExportedOrders } = this.props;

        if (!Array.isArray(notExportedOrders) || notExportedOrders.length === 0) {
            return uniqueIds;
        }

        notExportedOrders.map(item => {
            if (uniqueIds.includes(item.orderId)) {
                return;
            }
            return uniqueIds.push(item.orderId);
        });

        return uniqueIds;
    };

    handleChangeAllSelect = (ev) => {
        const { checked } = ev.target;

        if (checked) {
            const uniqueIds = this.getUniqueOrderIds();

            this.props.handleCheckOrders(uniqueIds);
        } else {
            this.props.handleCheckOrders([]);
        }
    };

    getColumns = () => {
        const { selectedNotExportedOrders, handleCheckOrders } = this.props;
        const columns = [];
        const isAllChecked =
            Array.isArray(selectedNotExportedOrders) && selectedNotExportedOrders.length ?
                this.getUniqueOrderIds().length === selectedNotExportedOrders.length : false;

        columns.push({
            Cell: ({ original }) => (
                <CustomCheckbox
                    key={original.orderId}
                    className="checkbox"
                    checked={selectedNotExportedOrders.includes(original.orderId)}
                    onChange={() => handleCheckOrders(original.orderId)}
                />
            ),
            Header: () => (
                <input
                    type="checkbox"
                    className="checkbox"
                    checked={isAllChecked}
                    onChange={this.handleChangeAllSelect}
                />
            ),
            headerClassName: "text-left",
            sortable: false,
            filterable: false,
            resizable: false,
            minResizeWidth: 40,
            width: 40,
            className: "d-flex"
        });
        columns.push({
            Header: "Order #",
            headerClassName: "text-left",
            accessor: "orderId"
        });
        columns.push({
            Header: "Merchandiser",
            headerClassName: "text-left",
            accessor: "merchandiser"
        });
        columns.push({
            Header: "Retailer",
            headerClassName: "text-left",
            accessor: "retailer"
        });
        columns.push({
            Header: "Job",
            headerClassName: "text-left",
            accessor: "jobNumber"
        });
        columns.push({
            Header: "Store #",
            headerClassName: "text-left",
            accessor: "storeNumber"
        });
        columns.push({
            Header: "Category",
            headerClassName: "text-left",
            accessor: "category"
        });
        columns.push({
            Header: "Title",
            headerClassName: "text-left",
            accessor: "title"
        });
        columns.push({
            Header: "UPC",
            headerClassName: "text-left",
            accessor: "upc"
        });
        columns.push({
            Header: "PO #",
            headerClassName: "text-left",
            accessor: "poNumber"
        });
        columns.push({
            Header: "Quantity",
            headerClassName: "text-left",
            accessor: "quantity"
        });
        columns.push({
            id: "cost",
            Header: "Cost",
            headerClassName: "text-left",
            accessor: original => (original.cost ?
                `$${original.cost.toFixed(2)}` : "")
        });
        columns.push({
            id: "retail",
            Header: "Retail",
            headerClassName: "text-left",
            accessor: original => (original.retail ?
                `$${original.retail.toFixed(2)}` : "")
        });

        return columns;
    };

    render() {
        const {
            notExportedOrdersLoading,
            notExportedOrders
        } = this.props;

        return (
            <div className="dashboard">
                <div className="position-relative">
                    {!notExportedOrdersLoading || <Spinner/>}
                    <div className="mb-4">
                        <ReactTable
                            data={notExportedOrders}
                            columns={this.getColumns()}
                            headerClassName="table-header"
                            showPagination={false}
                            pageSize={Math.max(notExportedOrders.length, 20)}
                            resizable
                            className="-striped -highlight"
                            filterable={false}
                            defaultFilterMethod={filterCaseInsensitive}
                            getNoDataProps={() => ({
                                style: {
                                    zIndex: 0
                                }
                            })}
                            style={{
                                height: "calc(100vh - 300px)",
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

NotExportedOrdersList.propTypes = {
    handleCheckOrders: PropTypes.func.isRequired,
    selectedNotExportedOrders: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
    notExportedOrdersLoading: state.export.notExportedOrdersLoading,
    notExportedOrders: state.export.notExportedOrders
});

export default connect(
    mapStateToProps
)(NotExportedOrdersList);
